"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rollDice = exports.rollGameId = void 0;
const lodash_1 = require("lodash");
const rollGameId = () => (0, lodash_1.times)(6, () => (0, lodash_1.random)(0, 9)).join('');
exports.rollGameId = rollGameId;
const rollDie = () => (0, lodash_1.random)(1, 6);
const rollDice = () => ({
    die1: rollDie(),
    die2: rollDie(),
});
exports.rollDice = rollDice;
